// Auto-generated lender logo map
export const LENDER_LOGOS = {
  "Personal Loan": {
    "Aditya Birla Capital Limited": "/lender-logos/PL/Aditya Birla Capital Limited.jfif",
    "Axis Bank Limited": "/lender-logos/PL/Axis Bank Limited.png",
    "Axis Finance Ltd": "/lender-logos/PL/Axis Finance Ltd.webp",
    "Bajaj Finance Limited": "/lender-logos/PL/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/PL/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/PL/Bank of Baroda.png",
    "Bank of India": "/lender-logos/PL/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/PL/Bank of Maharashtra.jfif",
    "Canara Bank": "/lender-logos/PL/Canara Bank.png",
    "Central Bank of India": "/lender-logos/PL/Central Bank of India.png",
    "Cholamandalam Invest. And Finance CL": "/lender-logos/PL/Cholamandalam Invest. And Finance CL.jfif",
    "Citibank": "/lender-logos/PL/Citibank.svg",
    "City Union Bank": "/lender-logos/PL/City Union Bank.jpg",
    "Credit Saison": "/lender-logos/PL/Credit Saison.png",
    "DBS BANK LTD": "/lender-logos/PL/DBS BANK LTD.jfif",
    "DCB Bank": "/lender-logos/PL/DCB Bank.jfif",
    "Deutsche Bank": "/lender-logos/PL/Deutsche Bank.png",
    "Federal Bank": "/lender-logos/PL/Federal Bank.png",
    "Fibe (EarlySalary)": "/lender-logos/PL/Fibe (EarlySalary).png",
    "Finnable Credit Pvt Ltd.": "/lender-logos/PL/Finnable Credit Pvt Ltd..png",
    "HDFC Bank Limited": "/lender-logos/PL/HDFC Bank Limited.png",
    "HDFC Bank Limited (Digital Anywhere)": "/lender-logos/PL/HDFC Bank Limited (Digital Anywhere).png",
    "HSBC": "/lender-logos/PL/HSBC.svg",
    "ICICI Bank Limited": "/lender-logos/PL/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/PL/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/PL/IDFC First Bank Limited.png",
    "Incred Financial Services Ltd": "/lender-logos/PL/Incred Financial Services Ltd.png",
    "Indian Bank": "/lender-logos/PL/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/PL/Indian Overseas Bank.jpeg",
    "Indusind Bank Limited": "/lender-logos/PL/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/PL/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/PL/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/PL/Kotak Mahindra Bank Limited.png",
    "L&T Finance Limited": "/lender-logos/PL/L&T Finance Limited.webp",
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "MAS Financial Services Limited": "/lender-logos/PL/MAS Financial Services Limited.jpg",
    "Mahindra Finance": "/lender-logos/PL/Mahindra Finance.jfif",
    "Muthoot Finance Ltd": "/lender-logos/PL/Muthoot Finance Ltd.webp",
    "Piramal Capital & Housing Finance Ltd": "/lender-logos/PL/Piramal Capital & Housing Finance Ltd.png",
    "Poonawalla Fincorp Limited": "/lender-logos/PL/Poonawalla Fincorp Limited.jfif",
    "Prefr (Credit Vidya)": "/lender-logos/PL/Prefr (Credit Vidya).png",
    "Punjab & Sind Bank": "/lender-logos/PL/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/PL/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/PL/RBL Bank.png",
    "SMFG India Credit Company Limited": "/lender-logos/PL/SMFG India Credit Company Limited.png",
    "Shinhan Bank": "/lender-logos/PL/Shinhan Bank.png",
    "Shriram Finance Limited": "/lender-logos/PL/Shriram Finance Limited.png",
    "South Indian Bank": "/lender-logos/PL/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/PL/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/PL/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/PL/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/PL/Tata Capital.png",
    "Tata Capital Limited": "/lender-logos/PL/Tata Capital Limited.png",
    "The South Indian Bank Limited": "/lender-logos/PL/The South Indian Bank Limited.png",
    "UCO Bank": "/lender-logos/PL/UCO Bank.png",
    "Union Bank of India": "/lender-logos/PL/Union Bank of India.png",
    "Utkarsh Small Finance Bank Ltd": "/lender-logos/PL/Utkarsh Small Finance Bank Ltd.png",
    "Yes Bank Limited": "/lender-logos/PL/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/PL/IIFL Finance.png",
    "Hinduja Housing Finance": "/lender-logos/PL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/PL/Indiabulls Housing Finance.png",
    "Piramal Finance": "/lender-logos/PL/Piramal Finance.png",
    "PNB Housing Finance": "/lender-logos/PL/PNB Housing Finance.png",
    "Aditya Birla Finance": "/lender-logos/PL/Aditya Birla Finance.png",
    "Reliance Home Finance": "/lender-logos/PL/Reliance Home Finance.svg",
  },
  "Business Loan": {
    "ARKA FINCAP LIMITED": "/lender-logos/BL/ARKA FINCAP LIMITED.jfif",
    "Aditya Birla Capital Limited": "/lender-logos/BL/Aditya Birla Capital Limited.jfif",
    "Ambit Finvest Pvt. Ltd.": "/lender-logos/BL/Ambit Finvest Pvt. Ltd..avif",
    "Ashv Finance": "/lender-logos/BL/Ashv Finance.png",
    "Axis Bank Limited": "/lender-logos/BL/Axis Bank Limited.png",
    "Axis Finance Ltd": "/lender-logos/BL/Axis Finance Ltd.webp",
    "Bajaj Finance Limited": "/lender-logos/BL/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/BL/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/BL/Bank of Baroda.png",
    "Bank of India": "/lender-logos/BL/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/BL/Bank of Maharashtra.jfif",
    "Bazaari GLobal Finance Limited": "/lender-logos/BL/Bazaari GLobal Finance Limited.png",
    "Canara Bank": "/lender-logos/BL/Canara Bank.png",
    "Central Bank of India": "/lender-logos/BL/Central Bank of India.png",
    "Cholamandalam Invest. & Finance CL": "/lender-logos/BL/Cholamandalam Invest. & Finance CL.jfif",
    "Citibank": "/lender-logos/BL/Citibank.svg",
    "City Union Bank": "/lender-logos/BL/City Union Bank.jpg",
    "Clix Capital Services Private Limited": "/lender-logos/BL/Clix Capital Services Private Limited.png",
    "Credit Saison": "/lender-logos/BL/Credit Saison.png",
    "DCB Bank": "/lender-logos/BL/DCB Bank.jfif",
    "Deutsche Bank AG": "/lender-logos/BL/Deutsche Bank AG.png",
    "Federal Bank": "/lender-logos/BL/Federal Bank.png",
    "Finable": "/lender-logos/BL/Finable.png",
    "Fintree Finance Pvt Ltd": "/lender-logos/BL/Fintree Finance Pvt Ltd.png",
    "Godrej Capital": "/lender-logos/BL/Godrej Capital.webp",
    "Gosree Finance Limited": "/lender-logos/BL/Gosree Finance Limited.png",
    "HDB Financial Services Limited": "/lender-logos/BL/HDB Financial Services Limited.png",
    "HDFC Bank Limited": "/lender-logos/BL/HDFC Bank Limited.png",
    "HSBC": "/lender-logos/BL/HSBC.svg",
    "Hero Fincorp Limited": "/lender-logos/BL/Hero Fincorp Limited.webp",
    "ICICI Bank Limited": "/lender-logos/BL/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/BL/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/BL/IDFC First Bank Limited.png",
    "Indian Bank": "/lender-logos/BL/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/BL/Indian Overseas Bank.jpeg",
    "Indifi Technologies Pvt Ltd": "/lender-logos/BL/Indifi Technologies Pvt Ltd.png",
    "Indusind Bank Limited": "/lender-logos/BL/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/BL/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/BL/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/BL/Kotak Mahindra Bank Limited.png",
    "Krazybee Services Private Limited": "/lender-logos/BL/Krazybee Services Private Limited.jfif",
    "L&T Finance Limited": "/lender-logos/BL/L&T Finance Limited.webp",
    "Lendingkart Finance Limited": "/lender-logos/BL/Lendingkart Finance Limited.png",
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "Loan Frame": "/lender-logos/BL/Loan Frame.png",
    "Loantap": "/lender-logos/BL/Loantap.png",
    "MAS Financial Services Limited": "/lender-logos/BL/MAS Financial Services Limited.jpg",
    "Mahindra Finance": "/lender-logos/BL/Mahindra Finance.jfif",
    "Moneywise Financial Services Pvt Ltd (SMC)": "/lender-logos/BL/Moneywise Financial Services Pvt Ltd (SMC).png",
    "Muthoot Finance Ltd": "/lender-logos/BL/Muthoot Finance Ltd.webp",
    "Piramal Capital & Housing Finance Ltd": "/lender-logos/BL/Piramal Capital & Housing Finance Ltd.png",
    "Poonawalla Fincorp Limited": "/lender-logos/BL/Poonawalla Fincorp Limited.jfif",
    "Protium": "/lender-logos/BL/Protium.png",
    "Punjab & Sind Bank": "/lender-logos/BL/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/BL/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/BL/RBL Bank.png",
    "SBM Bank (India) Limited": "/lender-logos/BL/SBM Bank (India) Limited.png",
    "SMFG India Credit Company Limited": "/lender-logos/BL/SMFG India Credit Company Limited.png",
    "Shriram Finance Limited": "/lender-logos/BL/Shriram Finance Limited.png",
    "South Indian Bank": "/lender-logos/BL/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/BL/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/BL/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/BL/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/BL/Tata Capital.png",
    "Tata Capital Limited": "/lender-logos/BL/Tata Capital Limited.png",
    "U Gro Capital Ltd": "/lender-logos/BL/U Gro Capital Ltd.webp",
    "UCO Bank": "/lender-logos/BL/UCO Bank.png",
    "Union Bank of India": "/lender-logos/BL/Union Bank of India.png",
    "Yes Bank Limited": "/lender-logos/BL/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/BL/IIFL Finance.png",
    "Hinduja Housing Finance": "/lender-logos/BL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/BL/Indiabulls Housing Finance.png",
    "Piramal Finance": "/lender-logos/BL/Piramal Finance.png",
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Aditya Birla Finance": "/lender-logos/BL/Aditya Birla Finance.png",
    "Reliance Home Finance": "/lender-logos/BL/Reliance Home Finance.svg",
  },
  "Home Loan": {
    "AGRIM Housing Finance": "/lender-logos/HL/AGRIM Housing Finance.png",
    "APAC Housing Finance": "/lender-logos/HL/APAC Housing Finance.jpg",
    "ART Housing Finance": "/lender-logos/HL/ART Housing Finance.png",
    "AU Small Finance Bank": "/lender-logos/HL/AU Small Finance Bank.png",
    "Aadhar Housing Finance": "/lender-logos/HL/Aadhar Housing Finance.png",
    "Aavas Financiers": "/lender-logos/HL/Aavas Financiers.png",
    "Abhyudaya Co#U2011op Bank": "/lender-logos/HL/Abhyudaya Co#U2011op Bank.png",
    "Abhyudaya Co‑op Bank": "/lender-logos/HL/Abhyudaya Co‑op Bank.png",
    "Adani Housing Finance": "/lender-logos/HL/Adani Housing Finance.jfif",
    "Aditya Birla Housing Finance": "/lender-logos/HL/Aditya Birla Housing Finance.webp",
    "Aham Housing Finance": "/lender-logos/HL/Aham Housing Finance.png",
    "Altum Credo Home Finance": "/lender-logos/HL/Altum Credo Home Finance.png",
    "Anand Housing Finance": "/lender-logos/HL/Anand Housing Finance.jpg",
    "Andhra Pradesh Grameena Vikas Bank": "/lender-logos/HL/Andhra Pradesh Grameena Vikas Bank.png",
    "Aptus Value Housing Finance": "/lender-logos/HL/Aptus Value Housing Finance.jfif",
    "Arunachal Pradesh Rural Bank": "/lender-logos/HL/Arunachal Pradesh Rural Bank.png",
    "Aryarth Housing Finance": "/lender-logos/HL/Aryarth Housing Finance.jfif",
    "Aryavart Bank": "/lender-logos/HL/Aryavart Bank.jfif",
    "Assam Gramin Vikash Bank": "/lender-logos/HL/Assam Gramin Vikash Bank.webp",
    "Assam Gramin Vikash Banklogo": "/lender-logos/HL/Assam Gramin Vikash Banklogo.webp",
    "Aviom India Housing Finance": "/lender-logos/HL/Aviom India Housing Finance.png",
    "Axis Bank-logo": "/lender-logos/HL/Axis Bank-logo.png",
    "Baid Housing Finance": "/lender-logos/HL/Baid Housing Finance.png",
    "Bajaj Finance": "/lender-logos/HL/Bajaj Finance.png",
    "Bajaj Housing Finance": "/lender-logos/HL/Bajaj Housing Finance.gif",
    "Bandhan Bank": "/lender-logos/HL/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/HL/Bank of Baroda.png",
    "Bank of India": "/lender-logos/HL/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/HL/Bank of Maharashtra.jfif",
    "Baroda Rajasthan Kshetriya Gramin Bank": "/lender-logos/HL/Baroda Rajasthan Kshetriya Gramin Bank.jfif",
    "Baroda UP Bank": "/lender-logos/HL/Baroda UP Bank.png",
    "Bharat Co#U2011op Bank": "/lender-logos/HL/Bharat Co#U2011op Bank.png",
    "Bharat Co‑op Bank": "/lender-logos/HL/Bharat Co‑op Bank.png",
    "Bihar Gramin Bank": "/lender-logos/HL/Bihar Gramin Bank.png",
    "CSB Bank": "/lender-logos/HL/CSB Bank.jpg",
    "Can Fin Homes": "/lender-logos/HL/Can Fin Homes.png",
    "Canara Bank": "/lender-logos/HL/Canara Bank.png",
    "Capital India Home Loans": "/lender-logos/HL/Capital India Home Loans.webp",
    "Capital Small Finance Bank": "/lender-logos/HL/Capital Small Finance Bank.png",
    "Capri Global Housing Finance": "/lender-logos/HL/Capri Global Housing Finance.jpg",
    "Cent Bank Home Finance": "/lender-logos/HL/Cent Bank Home Finance.jpg",
    "Central Bank of India": "/lender-logos/HL/Central Bank of India.png",
    "Centrum Housing Finance": "/lender-logos/HL/Centrum Housing Finance.png",
    "Chhattisgarh Rajya Gramin Bank": "/lender-logos/HL/Chhattisgarh Rajya Gramin Bank.png",
    "Citibank": "/lender-logos/HL/Citibank.svg",
    "City Union Bank": "/lender-logos/HL/City Union Bank.jpg",
    "Clix Housing Finance": "/lender-logos/HL/Clix Housing Finance.png",
    "Cosmos Co#U2011operative Bank": "/lender-logos/HL/Cosmos Co#U2011operative Bank.png",
    "Cosmos Co‑operative Bank": "/lender-logos/HL/Cosmos Co‑operative Bank.png",
    "DCB Bank": "/lender-logos/HL/DCB Bank.jfif",
    "DMI Housing Finance": "/lender-logos/HL/DMI Housing Finance.png",
    "Dakshin Bihar Gramin Bank": "/lender-logos/HL/Dakshin Bihar Gramin Bank.png",
    "Deutsche Bank": "/lender-logos/HL/Deutsche Bank.png",
    "Dhanlaxmi Bank": "/lender-logos/HL/Dhanlaxmi Bank.jfif",
    "ESAF Small Finance Bank": "/lender-logos/HL/ESAF Small Finance Bank.png",
    "Easy Home Finance": "/lender-logos/HL/Easy Home Finance.jfif",
    "Ellaquai Dehati Bank": "/lender-logos/HL/Ellaquai Dehati Bank.png",
    "Equitas Small Finance Bank": "/lender-logos/HL/Equitas Small Finance Bank.png",
    "Essel Finance Home Loans": "/lender-logos/HL/Essel Finance Home Loans.jfif",
    "Federal Bank": "/lender-logos/HL/Federal Bank.png",
    "GIC Housing Finance": "/lender-logos/HL/GIC Housing Finance.png",
    "Godrej Housing Finance": "/lender-logos/HL/Godrej Housing Finance.webp",
    "Gramin Bank of Aryavart": "/lender-logos/HL/Gramin Bank of Aryavart.jfif",
    "Greater Bombay Co#U2011op Bank": "/lender-logos/HL/Greater Bombay Co#U2011op Bank.png",
    "Greater Bombay Co‑op Bank": "/lender-logos/HL/Greater Bombay Co‑op Bank.png",
    "HDFC Bank-logo": "/lender-logos/HL/HDFC Bank-logo.png",
    "HDFC Bank-logoo": "/lender-logos/HL/HDFC Bank-logoo.png",
    "HSBC": "/lender-logos/HL/HSBC.svg",
    "HUDCO (Housing & Urban Dev. Corp.)": "/lender-logos/HL/HUDCO (Housing & Urban Dev. Corp.).png",
    "Hero Housing Finance": "/lender-logos/HL/Hero Housing Finance.webp",
    "Himachal Pradesh Gramin Bank": "/lender-logos/HL/Himachal Pradesh Gramin Bank.png",
    "ICICI Bank": "/lender-logos/HL/ICICI Bank.png",
    "ICICI Home Finance": "/lender-logos/HL/ICICI Home Finance.webp",
    "IDBI Bank": "/lender-logos/HL/IDBI Bank.jpg",
    "IDFC FIRST Bank l": "/lender-logos/HL/IDFC FIRST Bank l.png",
    "Ind Bank Housing": "/lender-logos/HL/Ind Bank Housing.jpg",
    "India Home Loan Limited": "/lender-logos/HL/India Home Loan Limited.jfif",
    "India Shelter Finance Corporation": "/lender-logos/HL/India Shelter Finance Corporation.webp",
    "Indian Bank": "/lender-logos/HL/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/HL/Indian Overseas Bank.jpeg",
    "IndoStar Home Finance": "/lender-logos/HL/IndoStar Home Finance.webp",
    "IndusInd Bank": "/lender-logos/HL/IndusInd Bank.webp",
    "J&K Grameen Bank": "/lender-logos/HL/J&K Grameen Bank.png",
    "JM Financial Home Loans": "/lender-logos/HL/JM Financial Home Loans.png",
    "Jammu & Kashmir Bank": "/lender-logos/HL/Jammu & Kashmir Bank.svg",
    "Jana Small Finance Bank": "/lender-logos/HL/Jana Small Finance Bank.png",
    "Jharkhand Rajya Gramin Bank": "/lender-logos/HL/Jharkhand Rajya Gramin Bank.png",
    "KIFS Housing Finance": "/lender-logos/HL/KIFS Housing Finance.png",
    "Karnataka Bank": "/lender-logos/HL/Karnataka Bank.gif",
    "Karur Vysya Bank-logo": "/lender-logos/HL/Karur Vysya Bank-logo.png",
    "Kerala Gramin Bank": "/lender-logos/HL/Kerala Gramin Bank.png",
    "Kotak Mahindra Bank-logo": "/lender-logos/HL/Kotak Mahindra Bank-logo.png",
    "LIC Housing Finance": "/lender-logos/HL/LIC Housing Finance.png",
    "MAS Rural Housing Finance": "/lender-logos/HL/MAS Rural Housing Finance.png",
    "Madhya Pradesh Gramin Bank": "/lender-logos/HL/Madhya Pradesh Gramin Bank.png",
    "Madhyanchal Gramin Bank": "/lender-logos/HL/Madhyanchal Gramin Bank.png",
    "Maharashtra Gramin Bank": "/lender-logos/HL/Maharashtra Gramin Bank.png",
    "Mahindra Finance": "/lender-logos/HL/Mahindra Finance.jfif",
    "Mahindra Rural Housing Finance": "/lender-logos/HL/Mahindra Rural Housing Finance.jfif",
    "Manappuram Home Finance": "/lender-logos/HL/Manappuram Home Finance.webp",
    "Manipal Housing Finance Syndicate": "/lender-logos/HL/Manipal Housing Finance Syndicate.png",
    "Manipur Rural Bank": "/lender-logos/HL/Manipur Rural Bank.png",
    "Meghalaya Rural Bank": "/lender-logos/HL/Meghalaya Rural Bank.png",
    "Motilal Oswal Home Finance": "/lender-logos/HL/Motilal Oswal Home Finance.png",
    "Muthoot Homefin": "/lender-logos/HL/Muthoot Homefin.webp",
    "Muthoot Housing Finance": "/lender-logos/HL/Muthoot Housing Finance.png",
    "Nagaland Rural Bank": "/lender-logos/HL/Nagaland Rural Bank.png",
    "Narmada Jhabua Gramin Bank": "/lender-logos/HL/Narmada Jhabua Gramin Bank.jfif",
    "Navarathna Housing Finance": "/lender-logos/HL/Navarathna Housing Finance.png",
    "Nido Housing Finance (Edelweiss)": "/lender-logos/HL/Nido Housing Finance (Edelweiss).png",
    "Nivara Home Finance": "/lender-logos/HL/Nivara Home Finance.jfif",
    "North East Small Finance Bank": "/lender-logos/HL/North East Small Finance Bank.png",
    "Odisha Gramya Bank": "/lender-logos/HL/Odisha Gramya Bank.png",
    "Orange City Housing Finance": "/lender-logos/HL/Orange City Housing Finance.png",
    "PNB Housing Finance": "/lender-logos/HL/PNB Housing Finance.webp",
    "Piramal Capital & Housing Finance": "/lender-logos/HL/Piramal Capital & Housing Finance.png",
    "Poonawalla Housing Finance": "/lender-logos/HL/Poonawalla Housing Finance.jfif",
    "Prathama UP Gramin Bank": "/lender-logos/HL/Prathama UP Gramin Bank.png",
    "Prosper Housing Finance": "/lender-logos/HL/Prosper Housing Finance.png",
    "Puduvai Bharathiar Grama Bank": "/lender-logos/HL/Puduvai Bharathiar Grama Bank.png",
    "Punjab & Maharashtra Co#U2011op Bank": "/lender-logos/HL/Punjab & Maharashtra Co#U2011op Bank.jfif",
    "Punjab & Maharashtra Co‑op Bank": "/lender-logos/HL/Punjab & Maharashtra Co‑op Bank.jfif",
    "Punjab & Sind Bank": "/lender-logos/HL/Punjab & Sind Bank.jpg",
    "Punjab Gramin Bank": "/lender-logos/HL/Punjab Gramin Bank.webp",
    "Punjab National Bank": "/lender-logos/HL/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/HL/RBL Bank.png",
    "REPCO Home Finance": "/lender-logos/HL/REPCO Home Finance.jfif",
    "Rajasthan Marudhara Gramin Bank": "/lender-logos/HL/Rajasthan Marudhara Gramin Bank.png",
    "Religare Housing Dev Finance": "/lender-logos/HL/Religare Housing Dev Finance.avif",
    "Roha Housing Finance": "/lender-logos/HL/Roha Housing Finance.png",
    "SEWA Grih Rin": "/lender-logos/HL/SEWA Grih Rin.png",
    "SMFG India Home Finance": "/lender-logos/HL/SMFG India Home Finance.png",
    "SRG Housing Finance": "/lender-logos/HL/SRG Housing Finance.png",
    "Sammaan Capital (Indiabulls HF)": "/lender-logos/HL/Sammaan Capital (Indiabulls HF).webp",
    "Saral Home Finance": "/lender-logos/HL/Saral Home Finance.jfif",
    "Saraswat Bank": "/lender-logos/HL/Saraswat Bank.png",
    "Sarva Haryana Gramin Bank": "/lender-logos/HL/Sarva Haryana Gramin Bank.png",
    "Satin Housing Finance": "/lender-logos/HL/Satin Housing Finance.png",
    "Shamrao Vithal Co#U2011op Bank": "/lender-logos/HL/Shamrao Vithal Co#U2011op Bank.png",
    "Shamrao Vithal Co‑op Bank": "/lender-logos/HL/Shamrao Vithal Co‑op Bank.png",
    "Shivalik Small Finance Bank": "/lender-logos/HL/Shivalik Small Finance Bank.png",
    "Shubham Housing Finance": "/lender-logos/HL/Shubham Housing Finance.png",
    "South Indian Bank": "/lender-logos/HL/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/HL/Standard Chartered Bank.png",
    "Star Housing Finance": "/lender-logos/HL/Star Housing Finance.jfif",
    "State Bank of India": "/lender-logos/HL/State Bank of India.png",
    "Sundaram Home Finance": "/lender-logos/HL/Sundaram Home Finance.png",
    "Suryoday Small Finance Bank": "/lender-logos/HL/Suryoday Small Finance Bank.webp",
    "Svatantra Micro Housing Finance": "/lender-logos/HL/Svatantra Micro Housing Finance.png",
    "Swagat Housing Finance": "/lender-logos/HL/Swagat Housing Finance.png",
    "Swarna Pragati Housing Microfinance": "/lender-logos/HL/Swarna Pragati Housing Microfinance.png",
    "TJSB Sahakari Bank": "/lender-logos/HL/TJSB Sahakari Bank.png",
    "Tamil Nadu Grama Bank": "/lender-logos/HL/Tamil Nadu Grama Bank.png",
    "Tamilnad Mercantile Bank": "/lender-logos/HL/Tamilnad Mercantile Bank.webp",
    "Tata Capital Housing Finance": "/lender-logos/HL/Tata Capital Housing Finance.png",
    "Telangana Grameena Bank": "/lender-logos/HL/Telangana Grameena Bank.jpg",
    "Tripura Gramin Bank": "/lender-logos/HL/Tripura Gramin Bank.png",
    "Truhome Finance (ex#U2011Shriram Housing)": "/lender-logos/HL/Truhome Finance (ex#U2011Shriram Housing).png",
    "Truhome Finance (ex‑Shriram Housing)": "/lender-logos/HL/Truhome Finance (ex‑Shriram Housing).png",
    "UCO Bank": "/lender-logos/HL/UCO Bank.png",
    "Ujjivan Small Finance Bank": "/lender-logos/HL/Ujjivan Small Finance Bank.webp",
    "Ummeed Housing Finance": "/lender-logos/HL/Ummeed Housing Finance.png",
    "Union Bank of India": "/lender-logos/HL/Union Bank of India.png",
    "Unity Small Finance Bank": "/lender-logos/HL/Unity Small Finance Bank.png",
    "Utkarsh Small Finance Bank": "/lender-logos/HL/Utkarsh Small Finance Bank.png",
    "Uttar Bihar Gramin Bank": "/lender-logos/HL/Uttar Bihar Gramin Bank.jfif",
    "Uttarakhand Gramin Bank": "/lender-logos/HL/Uttarakhand Gramin Bank.png",
    "Uttarbanga Kshetriya Gramin Bank": "/lender-logos/HL/Uttarbanga Kshetriya Gramin Bank.jfif",
    "VIVA Home Finance": "/lender-logos/HL/VIVA Home Finance.png",
    "Varashakti Housing Finance": "/lender-logos/HL/Varashakti Housing Finance.png",
    "Vastu Housing Finance": "/lender-logos/HL/Vastu Housing Finance.jfif",
    "Wonder Home Finance": "/lender-logos/HL/Wonder Home Finance.png",
    "YES Bank": "/lender-logos/HL/YES Bank.png",
    "sbi_logo": "/lender-logos/HL/sbi_logo.png",
    "IIFL Finance": "/lender-logos/HL/IIFL Finance.png",
    "Hinduja Housing Finance": "/lender-logos/HL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/HL/Indiabulls Housing Finance.png",
    "Piramal Finance": "/lender-logos/HL/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/HL/Aditya Birla Finance.png",
    "LIC Housing Finance Ltd": "/lender-logos/HL/LIC Housing Finance Ltd.png",
    "L&T Finance": "/lender-logos/HL/L&T Finance Limited.webp",
    "Shriram Finance": "/lender-logos/HL/Shriram Finance Limited.png",
    "Reliance Home Finance": "/lender-logos/HL/Reliance Home Finance.svg",
  },
  "Loan Against Property (LAP)": {
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Asirvad Micro Finance": "/lender-logos/LAP/Asirvad Micro Finance.png",
    "Axis Bank Limited": "/lender-logos/LAP/Axis Bank Limited.png",
    "Aye Finance": "/lender-logos/LAP/Aye Finance.avif",
    "Bajaj Finance": "/lender-logos/LAP/Bajaj Finance.png",
    "Bandhan Bank": "/lender-logos/LAP/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/LAP/Bank of Baroda.png",
    "Bank of India": "/lender-logos/LAP/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/LAP/Bank of Maharashtra.jfif",
    "Belstar Microfinance": "/lender-logos/LAP/Belstar Microfinance.png",
    "Canara Bank": "/lender-logos/LAP/Canara Bank.png",
    "Central Bank of India": "/lender-logos/LAP/Central Bank of India.png",
    "Citibank": "/lender-logos/LAP/Citibank.svg",
    "City Union Bank": "/lender-logos/LAP/City Union Bank.jpg",
    "Credilio": "/lender-logos/LAP/Credilio.png",
    "Credit Saison India": "/lender-logos/LAP/Credit Saison India.png",
    "CreditAccess Grameen": "/lender-logos/LAP/CreditAccess Grameen.png",
    "CreditMantri-logo": "/lender-logos/LAP/CreditMantri-logo.webp",
    "DCB Bank": "/lender-logos/LAP/DCB Bank.jfif",
    "Deal4Loans": "/lender-logos/LAP/Deal4Loans.png",
    "Deutsche Bank": "/lender-logos/LAP/Deutsche Bank.png",
    "Dialabank": "/lender-logos/LAP/Dialabank.png",
    "Federal Bank": "/lender-logos/LAP/Federal Bank.png",
    "Five Star Business Finance": "/lender-logos/LAP/Five Star Business Finance.png",
    "FlexiLoans": "/lender-logos/LAP/FlexiLoans.png",
    "HDFC Bank Limited": "/lender-logos/LAP/HDFC Bank Limited.png",
    "HSBC": "/lender-logos/LAP/HSBC.svg",
    "Hero FinCorp": "/lender-logos/LAP/Hero FinCorp.webp",
    "Home First Finance Company": "/lender-logos/LAP/Home First Finance Company.png",
    "ICICI Bank Limited": "/lender-logos/LAP/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/LAP/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/LAP/IDFC First Bank Limited.png",
    "India Shelter Finance": "/lender-logos/LAP/India Shelter Finance.webp",
    "IndiaLends": "/lender-logos/LAP/IndiaLends.png",
    "Indian Bank": "/lender-logos/LAP/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/LAP/Indian Overseas Bank.jpeg",
    "Indusind Bank Limited": "/lender-logos/LAP/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/LAP/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/LAP/Karur Vysya Bank.png",
    "Kosamattam Finance": "/lender-logos/LAP/Kosamattam Finance.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/LAP/Kotak Mahindra Bank Limited.png",
    "LoanTap": "/lender-logos/LAP/LoanTap.png",
    "Loanbaba": "/lender-logos/LAP/Loanbaba.jfif",
    "Mahindra Finance": "/lender-logos/LAP/Mahindra Finance.png",
    "Manappuram Finance": "/lender-logos/LAP/Manappuram Finance.png",
    "Muthoot Finance": "/lender-logos/LAP/Muthoot Finance.webp",
    "Muthoot Fincorp": "/lender-logos/LAP/Muthoot Fincorp.jfif",
    "MyMoneyMantra-logo": "/lender-logos/LAP/MyMoneyMantra-logo.avif",
    "Punjab & Sind Bank": "/lender-logos/LAP/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/LAP/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/LAP/RBL Bank.png",
    "SBI (Business LAP)": "/lender-logos/LAP/SBI (Business LAP).png",
    "SMFG India Credit (Fullerton)": "/lender-logos/LAP/SMFG India Credit (Fullerton).png",
    "Satin Creditcare (via SFL + SHFL)": "/lender-logos/LAP/Satin Creditcare (via SFL + SHFL).png",
    "Satya MicroCapital": "/lender-logos/LAP/Satya MicroCapital.png",
    "Shriram Housing Finance": "/lender-logos/LAP/Shriram Housing Finance.jfif",
    "South Indian Bank": "/lender-logos/LAP/South Indian Bank.png",
    "Spandana Sphoorty": "/lender-logos/LAP/Spandana Sphoorty.png",
    "Standard Chartered Bank": "/lender-logos/LAP/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/LAP/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/LAP/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/LAP/Tata Capital.png",
    "UCO Bank": "/lender-logos/LAP/UCO Bank.png",
    "Ugro Capital": "/lender-logos/LAP/Ugro Capital.webp",
    "Union Bank of India": "/lender-logos/LAP/Union Bank of India.png",
    "Veritas Finance": "/lender-logos/LAP/Veritas Finance.png",
    "Wishfin": "/lender-logos/LAP/Wishfin.png",
    "Yes Bank Limited": "/lender-logos/LAP/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/LAP/IIFL Finance.png",
    "Hinduja Housing Finance": "/lender-logos/LAP/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/LAP/Indiabulls Housing Finance.png",
    "Piramal Finance": "/lender-logos/LAP/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/LAP/Aditya Birla Finance.png",
    "LIC Housing Finance Ltd": "/lender-logos/LAP/LIC Housing Finance Ltd.png",
    "L&T Finance": "/lender-logos/LAP/L&T Finance Limited.webp",
    "Shriram Finance": "/lender-logos/LAP/Shriram Finance Limited.png",
    "Reliance Home Finance": "/lender-logos/LAP/Reliance Home Finance.svg",
  },
  "Car Loan": {
    "Hinduja Housing Finance": "/lender-logos/BL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/BL/Indiabulls Housing Finance.png",
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Reliance Home Finance": "/lender-logos/BL/Reliance Home Finance.svg",
    "ARKA FINCAP LIMITED": "/lender-logos/CL/ARKA FINCAP LIMITED.jfif",
    "Aditya Birla Capital Limited": "/lender-logos/CL/Aditya Birla Capital Limited.jfif",
    "Ambit Finvest Pvt. Ltd.": "/lender-logos/CL/Ambit Finvest Pvt. Ltd..avif",
    "Ashv Finance": "/lender-logos/CL/Ashv Finance.png",
    "Axis Bank Limited": "/lender-logos/CL/Axis Bank Limited.png",
    "Axis Finance Ltd": "/lender-logos/CL/Axis Finance Ltd.webp",
    "Bajaj Finance Limited": "/lender-logos/CL/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/CL/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/CL/Bank of Baroda.png",
    "Bank of India": "/lender-logos/CL/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/CL/Bank of Maharashtra.jfif",
    "Bazaari GLobal Finance Limited": "/lender-logos/CL/Bazaari GLobal Finance Limited.png",
    "Canara Bank": "/lender-logos/CL/Canara Bank.png",
    "Central Bank of India": "/lender-logos/CL/Central Bank of India.png",
    "Cholamandalam Invest. & Finance CL": "/lender-logos/CL/Cholamandalam Invest. & Finance CL.jfif",
    "Citibank": "/lender-logos/CL/Citibank.svg",
    "City Union Bank": "/lender-logos/CL/City Union Bank.jpg",
    "Clix Capital Services Private Limited": "/lender-logos/CL/Clix Capital Services Private Limited.png",
    "Credit Saison": "/lender-logos/CL/Credit Saison.png",
    "DCB Bank": "/lender-logos/CL/DCB Bank.jfif",
    "Deutsche Bank AG": "/lender-logos/CL/Deutsche Bank AG.png",
    "Federal Bank": "/lender-logos/CL/Federal Bank.png",
    "Finable": "/lender-logos/CL/Finable.png",
    "Fintree Finance Pvt Ltd": "/lender-logos/CL/Fintree Finance Pvt Ltd.png",
    "Godrej Capital": "/lender-logos/CL/Godrej Capital.webp",
    "Gosree Finance Limited": "/lender-logos/CL/Gosree Finance Limited.png",
    "HDB Financial Services Limited": "/lender-logos/CL/HDB Financial Services Limited.png",
    "HDFC Bank Limited": "/lender-logos/CL/HDFC Bank Limited.png",
    "HSBC": "/lender-logos/CL/HSBC.svg",
    "Hero Fincorp Limited": "/lender-logos/CL/Hero Fincorp Limited.webp",
    "ICICI Bank Limited": "/lender-logos/CL/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/CL/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/CL/IDFC First Bank Limited.png",
    "Indian Bank": "/lender-logos/CL/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/CL/Indian Overseas Bank.jpeg",
    "Indifi Technologies Pvt Ltd": "/lender-logos/CL/Indifi Technologies Pvt Ltd.png",
    "Indusind Bank Limited": "/lender-logos/CL/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/CL/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/CL/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/CL/Kotak Mahindra Bank Limited.png",
    "Krazybee Services Private Limited": "/lender-logos/CL/Krazybee Services Private Limited.jfif",
    "L&T Finance Limited": "/lender-logos/CL/L&T Finance Limited.webp",
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "Lendingkart Finance Limited": "/lender-logos/CL/Lendingkart Finance Limited.png",
    "Loan Frame": "/lender-logos/CL/Loan Frame.png",
    "Loantap": "/lender-logos/CL/Loantap.png",
    "MAS Financial Services Limited": "/lender-logos/CL/MAS Financial Services Limited.jpg",
    "Mahindra Finance": "/lender-logos/CL/Mahindra Finance.jfif",
    "Moneywise Financial Services Pvt Ltd (SMC)": "/lender-logos/CL/Moneywise Financial Services Pvt Ltd (SMC).png",
    "Muthoot Finance Ltd": "/lender-logos/CL/Muthoot Finance Ltd.webp",
    "Piramal Capital & Housing Finance Ltd": "/lender-logos/CL/Piramal Capital & Housing Finance Ltd.png",
    "Poonawalla Fincorp Limited": "/lender-logos/CL/Poonawalla Fincorp Limited.jfif",
    "Protium": "/lender-logos/CL/Protium.png",
    "Punjab & Sind Bank": "/lender-logos/CL/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/CL/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/CL/RBL Bank.png",
    "SBM Bank (India) Limited": "/lender-logos/CL/SBM Bank (India) Limited.png",
    "SMFG India Credit Company Limited": "/lender-logos/CL/SMFG India Credit Company Limited.png",
    "Shriram Finance Limited": "/lender-logos/CL/Shriram Finance Limited.png",
    "South Indian Bank": "/lender-logos/CL/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/CL/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/CL/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/CL/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/CL/Tata Capital.png",
    "Tata Capital Limited": "/lender-logos/CL/Tata Capital Limited.png",
    "U Gro Capital Ltd": "/lender-logos/CL/U Gro Capital Ltd.webp",
    "UCO Bank": "/lender-logos/CL/UCO Bank.png",
    "Union Bank of India": "/lender-logos/CL/Union Bank of India.png",
    "Yes Bank Limited": "/lender-logos/CL/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/CL/IIFL Finance.png",
    "Piramal Finance": "/lender-logos/CL/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/CL/Aditya Birla Finance.png",
  },
  "Education Loan": {
    "ARKA FINCAP LIMITED": "/lender-logos/EL/ARKA FINCAP LIMITED.jfif",
    "Aditya Birla Capital Limited": "/lender-logos/EL/Aditya Birla Capital Limited.jfif",
    "Ambit Finvest Pvt. Ltd.": "/lender-logos/EL/Ambit Finvest Pvt. Ltd..avif",
    "Ashv Finance": "/lender-logos/EL/Ashv Finance.png",
    "Axis Bank Limited": "/lender-logos/EL/Axis Bank Limited.png",
    "Axis Finance Ltd": "/lender-logos/EL/Axis Finance Ltd.webp",
    "Bajaj Finance Limited": "/lender-logos/EL/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/EL/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/EL/Bank of Baroda.png",
    "Bank of India": "/lender-logos/EL/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/EL/Bank of Maharashtra.jfif",
    "Bazaari GLobal Finance Limited": "/lender-logos/EL/Bazaari GLobal Finance Limited.png",
    "Canara Bank": "/lender-logos/EL/Canara Bank.png",
    "Central Bank of India": "/lender-logos/EL/Central Bank of India.png",
    "Cholamandalam Invest. & Finance CL": "/lender-logos/EL/Cholamandalam Invest. & Finance CL.jfif",
    "Citibank": "/lender-logos/EL/Citibank.svg",
    "City Union Bank": "/lender-logos/EL/City Union Bank.jpg",
    "Clix Capital Services Private Limited": "/lender-logos/EL/Clix Capital Services Private Limited.png",
    "Credit Saison": "/lender-logos/EL/Credit Saison.png",
    "DCB Bank": "/lender-logos/EL/DCB Bank.jfif",
    "Deutsche Bank AG": "/lender-logos/EL/Deutsche Bank AG.png",
    "Federal Bank": "/lender-logos/EL/Federal Bank.png",
    "Finable": "/lender-logos/EL/Finable.png",
    "Fintree Finance Pvt Ltd": "/lender-logos/EL/Fintree Finance Pvt Ltd.png",
    "Godrej Capital": "/lender-logos/EL/Godrej Capital.webp",
    "Gosree Finance Limited": "/lender-logos/EL/Gosree Finance Limited.png",
    "HDB Financial Services Limited": "/lender-logos/EL/HDB Financial Services Limited.png",
    "HDFC Bank Limited": "/lender-logos/EL/HDFC Bank Limited.png",
    "Hinduja Housing Finance": "/lender-logos/BL/Hinduja Housing Finance.png",
    "HSBC": "/lender-logos/EL/HSBC.svg",
    "Hero Fincorp Limited": "/lender-logos/EL/Hero Fincorp Limited.webp",
    "Indiabulls Housing Finance": "/lender-logos/BL/Indiabulls Housing Finance.png",
    "ICICI Bank Limited": "/lender-logos/EL/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/EL/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/EL/IDFC First Bank Limited.png",
    "Indian Bank": "/lender-logos/EL/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/EL/Indian Overseas Bank.jpeg",
    "Indifi Technologies Pvt Ltd": "/lender-logos/EL/Indifi Technologies Pvt Ltd.png",
    "Indusind Bank Limited": "/lender-logos/EL/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/EL/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/EL/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/EL/Kotak Mahindra Bank Limited.png",
    "Krazybee Services Private Limited": "/lender-logos/EL/Krazybee Services Private Limited.jfif",
    "L&T Finance Limited": "/lender-logos/EL/L&T Finance Limited.webp",
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "Lendingkart Finance Limited": "/lender-logos/EL/Lendingkart Finance Limited.png",
    "Loan Frame": "/lender-logos/EL/Loan Frame.png",
    "Loantap": "/lender-logos/EL/Loantap.png",
    "MAS Financial Services Limited": "/lender-logos/EL/MAS Financial Services Limited.jpg",
    "Mahindra Finance": "/lender-logos/EL/Mahindra Finance.jfif",
    "Moneywise Financial Services Pvt Ltd (SMC)": "/lender-logos/EL/Moneywise Financial Services Pvt Ltd (SMC).png",
    "Muthoot Finance Ltd": "/lender-logos/EL/Muthoot Finance Ltd.webp",
    "Piramal Capital & Housing Finance Ltd": "/lender-logos/EL/Piramal Capital & Housing Finance Ltd.png",
    "Poonawalla Fincorp Limited": "/lender-logos/EL/Poonawalla Fincorp Limited.jfif",
    "Protium": "/lender-logos/EL/Protium.png",
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Punjab & Sind Bank": "/lender-logos/EL/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/EL/Punjab National Bank.png",
    "Reliance Home Finance": "/lender-logos/BL/Reliance Home Finance.svg",
    "RBL Bank": "/lender-logos/EL/RBL Bank.png",
    "SBM Bank (India) Limited": "/lender-logos/EL/SBM Bank (India) Limited.png",
    "SMFG India Credit Company Limited": "/lender-logos/EL/SMFG India Credit Company Limited.png",
    "Shriram Finance Limited": "/lender-logos/EL/Shriram Finance Limited.png",
    "South Indian Bank": "/lender-logos/EL/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/EL/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/EL/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/EL/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/EL/Tata Capital.png",
    "Tata Capital Limited": "/lender-logos/EL/Tata Capital Limited.png",
    "U Gro Capital Ltd": "/lender-logos/EL/U Gro Capital Ltd.webp",
    "UCO Bank": "/lender-logos/EL/UCO Bank.png",
    "Union Bank of India": "/lender-logos/EL/Union Bank of India.png",
    "Yes Bank Limited": "/lender-logos/EL/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/EL/IIFL Finance.png",
    "Piramal Finance": "/lender-logos/EL/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/EL/Aditya Birla Finance.png",
  },
  "Gold Loan": {
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "Hinduja Housing Finance": "/lender-logos/BL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/BL/Indiabulls Housing Finance.png",
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Reliance Home Finance": "/lender-logos/BL/Reliance Home Finance.svg",
    "Axis Bank Limited": "/lender-logos/GL/Axis Bank Limited.png",
    "Bajaj Finance Limited": "/lender-logos/GL/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/GL/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/GL/Bank of Baroda.png",
    "Bank of India": "/lender-logos/GL/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/GL/Bank of Maharashtra.jfif",
    "Canara Bank": "/lender-logos/GL/Canara Bank.png",
    "Central Bank of India": "/lender-logos/GL/Central Bank of India.png",
    "Citibank": "/lender-logos/GL/Citibank.svg",
    "City Union Bank": "/lender-logos/GL/City Union Bank.jpg",
    "DCB Bank": "/lender-logos/GL/DCB Bank.jfif",
    "Deutsche Bank": "/lender-logos/GL/Deutsche Bank.png",
    "Federal Bank": "/lender-logos/GL/Federal Bank.png",
    "HDFC Bank Limited": "/lender-logos/GL/HDFC Bank Limited.png",
    "HSBC": "/lender-logos/GL/HSBC.svg",
    "ICICI Bank Limited": "/lender-logos/GL/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/GL/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/GL/IDFC First Bank Limited.png",
    "Indian Bank": "/lender-logos/GL/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/GL/Indian Overseas Bank.jpeg",
    "Indusind Bank Limited": "/lender-logos/GL/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/GL/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/GL/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/GL/Kotak Mahindra Bank Limited.png",
    "Mahindra Finance": "/lender-logos/GL/Mahindra Finance.jfif",
    "Punjab & Sind Bank": "/lender-logos/GL/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/GL/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/GL/RBL Bank.png",
    "South Indian Bank": "/lender-logos/GL/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/GL/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/GL/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/GL/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/GL/Tata Capital.png",
    "UCO Bank": "/lender-logos/GL/UCO Bank.png",
    "Union Bank of India": "/lender-logos/GL/Union Bank of India.png",
    "Yes Bank Limited": "/lender-logos/GL/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/GL/IIFL Finance.png",
    "Piramal Finance": "/lender-logos/GL/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/GL/Aditya Birla Finance.png",
  },
  "Credit Card": {
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "Hinduja Housing Finance": "/lender-logos/BL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/BL/Indiabulls Housing Finance.png",
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Reliance Home Finance": "/lender-logos/BL/Reliance Home Finance.svg",
    "ARKA FINCAP LIMITED": "/lender-logos/CC/ARKA FINCAP LIMITED.jfif",
    "Aditya Birla Capital Limited": "/lender-logos/CC/Aditya Birla Capital Limited.jfif",
    "Ambit Finvest Pvt. Ltd.": "/lender-logos/CC/Ambit Finvest Pvt. Ltd..avif",
    "Ashv Finance": "/lender-logos/CC/Ashv Finance.png",
    "Axis Bank Limited": "/lender-logos/CC/Axis Bank Limited.png",
    "Axis Finance Ltd": "/lender-logos/CC/Axis Finance Ltd.webp",
    "Bajaj Finance Limited": "/lender-logos/CC/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/CC/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/CC/Bank of Baroda.png",
    "Bank of India": "/lender-logos/CC/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/CC/Bank of Maharashtra.jfif",
    "Bazaari GLobal Finance Limited": "/lender-logos/CC/Bazaari GLobal Finance Limited.png",
    "Canara Bank": "/lender-logos/CC/Canara Bank.png",
    "Central Bank of India": "/lender-logos/CC/Central Bank of India.png",
    "Cholamandalam Invest. & Finance CL": "/lender-logos/CC/Cholamandalam Invest. & Finance CL.jfif",
    "Citibank": "/lender-logos/CC/Citibank.svg",
    "City Union Bank": "/lender-logos/CC/City Union Bank.jpg",
    "Clix Capital Services Private Limited": "/lender-logos/CC/Clix Capital Services Private Limited.png",
    "Credit Saison": "/lender-logos/CC/Credit Saison.png",
    "DCB Bank": "/lender-logos/CC/DCB Bank.jfif",
    "Deutsche Bank AG": "/lender-logos/CC/Deutsche Bank AG.png",
    "Federal Bank": "/lender-logos/CC/Federal Bank.png",
    "Finable": "/lender-logos/CC/Finable.png",
    "Fintree Finance Pvt Ltd": "/lender-logos/CC/Fintree Finance Pvt Ltd.png",
    "Godrej Capital": "/lender-logos/CC/Godrej Capital.webp",
    "Gosree Finance Limited": "/lender-logos/CC/Gosree Finance Limited.png",
    "HDB Financial Services Limited": "/lender-logos/CC/HDB Financial Services Limited.png",
    "HDFC Bank Limited": "/lender-logos/CC/HDFC Bank Limited.png",
    "HSBC": "/lender-logos/CC/HSBC.svg",
    "Hero Fincorp Limited": "/lender-logos/CC/Hero Fincorp Limited.webp",
    "ICICI Bank Limited": "/lender-logos/CC/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/CC/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/CC/IDFC First Bank Limited.png",
    "Indian Bank": "/lender-logos/CC/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/CC/Indian Overseas Bank.jpeg",
    "Indifi Technologies Pvt Ltd": "/lender-logos/CC/Indifi Technologies Pvt Ltd.png",
    "Indusind Bank Limited": "/lender-logos/CC/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/CC/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/CC/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/CC/Kotak Mahindra Bank Limited.png",
    "Krazybee Services Private Limited": "/lender-logos/CC/Krazybee Services Private Limited.jfif",
    "L&T Finance Limited": "/lender-logos/CC/L&T Finance Limited.webp",
    "Lendingkart Finance Limited": "/lender-logos/CC/Lendingkart Finance Limited.png",
    "Loan Frame": "/lender-logos/CC/Loan Frame.png",
    "Loantap": "/lender-logos/CC/Loantap.png",
    "MAS Financial Services Limited": "/lender-logos/CC/MAS Financial Services Limited.jpg",
    "Mahindra Finance": "/lender-logos/CC/Mahindra Finance.jfif",
    "Moneywise Financial Services Pvt Ltd (SMC)": "/lender-logos/CC/Moneywise Financial Services Pvt Ltd (SMC).png",
    "Muthoot Finance Ltd": "/lender-logos/CC/Muthoot Finance Ltd.webp",
    "Piramal Capital & Housing Finance Ltd": "/lender-logos/CC/Piramal Capital & Housing Finance Ltd.png",
    "Poonawalla Fincorp Limited": "/lender-logos/CC/Poonawalla Fincorp Limited.jfif",
    "Protium": "/lender-logos/CC/Protium.png",
    "Punjab & Sind Bank": "/lender-logos/CC/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/CC/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/CC/RBL Bank.png",
    "SBM Bank (India) Limited": "/lender-logos/CC/SBM Bank (India) Limited.png",
    "SMFG India Credit Company Limited": "/lender-logos/CC/SMFG India Credit Company Limited.png",
    "Shriram Finance Limited": "/lender-logos/CC/Shriram Finance Limited.png",
    "South Indian Bank": "/lender-logos/CC/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/CC/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/CC/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/CC/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/CC/Tata Capital.png",
    "Tata Capital Limited": "/lender-logos/CC/Tata Capital Limited.png",
    "U Gro Capital Ltd": "/lender-logos/CC/U Gro Capital Ltd.webp",
    "UCO Bank": "/lender-logos/CC/UCO Bank.png",
    "Union Bank of India": "/lender-logos/CC/Union Bank of India.png",
    "Yes Bank Limited": "/lender-logos/CC/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/CC/IIFL Finance.png",
    "Piramal Finance": "/lender-logos/CC/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/CC/Aditya Birla Finance.png",
  },
  "Overdraft": {
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "Hinduja Housing Finance": "/lender-logos/BL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/BL/Indiabulls Housing Finance.png",
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Reliance Home Finance": "/lender-logos/BL/Reliance Home Finance.svg",
    "ARKA FINCAP LIMITED": "/lender-logos/OD/ARKA FINCAP LIMITED.jfif",
    "Aditya Birla Capital Limited": "/lender-logos/OD/Aditya Birla Capital Limited.jfif",
    "Ambit Finvest Pvt. Ltd.": "/lender-logos/OD/Ambit Finvest Pvt. Ltd..avif",
    "Ashv Finance": "/lender-logos/OD/Ashv Finance.png",
    "Axis Bank Limited": "/lender-logos/OD/Axis Bank Limited.png",
    "Axis Finance Ltd": "/lender-logos/OD/Axis Finance Ltd.webp",
    "Bajaj Finance Limited": "/lender-logos/OD/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/OD/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/OD/Bank of Baroda.png",
    "Bank of India": "/lender-logos/OD/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/OD/Bank of Maharashtra.jfif",
    "Bazaari GLobal Finance Limited": "/lender-logos/OD/Bazaari GLobal Finance Limited.png",
    "Canara Bank": "/lender-logos/OD/Canara Bank.png",
    "Central Bank of India": "/lender-logos/OD/Central Bank of India.png",
    "Cholamandalam Invest. & Finance CL": "/lender-logos/OD/Cholamandalam Invest. & Finance CL.jfif",
    "Citibank": "/lender-logos/OD/Citibank.svg",
    "City Union Bank": "/lender-logos/OD/City Union Bank.jpg",
    "Clix Capital Services Private Limited": "/lender-logos/OD/Clix Capital Services Private Limited.png",
    "Credit Saison": "/lender-logos/OD/Credit Saison.png",
    "DCB Bank": "/lender-logos/OD/DCB Bank.jfif",
    "Deutsche Bank AG": "/lender-logos/OD/Deutsche Bank AG.png",
    "Federal Bank": "/lender-logos/OD/Federal Bank.png",
    "Finable": "/lender-logos/OD/Finable.png",
    "Fintree Finance Pvt Ltd": "/lender-logos/OD/Fintree Finance Pvt Ltd.png",
    "Godrej Capital": "/lender-logos/OD/Godrej Capital.webp",
    "Gosree Finance Limited": "/lender-logos/OD/Gosree Finance Limited.png",
    "HDB Financial Services Limited": "/lender-logos/OD/HDB Financial Services Limited.png",
    "HDFC Bank Limited": "/lender-logos/OD/HDFC Bank Limited.png",
    "HSBC": "/lender-logos/OD/HSBC.svg",
    "Hero Fincorp Limited": "/lender-logos/OD/Hero Fincorp Limited.webp",
    "ICICI Bank Limited": "/lender-logos/OD/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/OD/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/OD/IDFC First Bank Limited.png",
    "Indian Bank": "/lender-logos/OD/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/OD/Indian Overseas Bank.jpeg",
    "Indifi Technologies Pvt Ltd": "/lender-logos/OD/Indifi Technologies Pvt Ltd.png",
    "Indusind Bank Limited": "/lender-logos/OD/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/OD/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/OD/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/OD/Kotak Mahindra Bank Limited.png",
    "Krazybee Services Private Limited": "/lender-logos/OD/Krazybee Services Private Limited.jfif",
    "L&T Finance Limited": "/lender-logos/OD/L&T Finance Limited.webp",
    "Lendingkart Finance Limited": "/lender-logos/OD/Lendingkart Finance Limited.png",
    "Loan Frame": "/lender-logos/OD/Loan Frame.png",
    "Loantap": "/lender-logos/OD/Loantap.png",
    "MAS Financial Services Limited": "/lender-logos/OD/MAS Financial Services Limited.jpg",
    "Mahindra Finance": "/lender-logos/OD/Mahindra Finance.jfif",
    "Moneywise Financial Services Pvt Ltd (SMC)": "/lender-logos/OD/Moneywise Financial Services Pvt Ltd (SMC).png",
    "Muthoot Finance Ltd": "/lender-logos/OD/Muthoot Finance Ltd.webp",
    "Piramal Capital & Housing Finance Ltd": "/lender-logos/OD/Piramal Capital & Housing Finance Ltd.png",
    "Poonawalla Fincorp Limited": "/lender-logos/OD/Poonawalla Fincorp Limited.jfif",
    "Protium": "/lender-logos/OD/Protium.png",
    "Punjab & Sind Bank": "/lender-logos/OD/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/OD/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/OD/RBL Bank.png",
    "SBM Bank (India) Limited": "/lender-logos/OD/SBM Bank (India) Limited.png",
    "SMFG India Credit Company Limited": "/lender-logos/OD/SMFG India Credit Company Limited.png",
    "Shriram Finance Limited": "/lender-logos/OD/Shriram Finance Limited.png",
    "South Indian Bank": "/lender-logos/OD/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/OD/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/OD/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/OD/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/OD/Tata Capital.png",
    "Tata Capital Limited": "/lender-logos/OD/Tata Capital Limited.png",
    "U Gro Capital Ltd": "/lender-logos/OD/U Gro Capital Ltd.webp",
    "UCO Bank": "/lender-logos/OD/UCO Bank.png",
    "Union Bank of India": "/lender-logos/OD/Union Bank of India.png",
    "Yes Bank Limited": "/lender-logos/OD/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/OD/IIFL Finance.png",
    "Piramal Finance": "/lender-logos/OD/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/OD/Aditya Birla Finance.png",
  },
  "Working Capital": {
    "LIC Housing Finance": "/lender-logos/BL/LIC Housing Finance.png",
    "Hinduja Housing Finance": "/lender-logos/BL/Hinduja Housing Finance.png",
    "Indiabulls Housing Finance": "/lender-logos/BL/Indiabulls Housing Finance.png",
    "PNB Housing Finance": "/lender-logos/BL/PNB Housing Finance.png",
    "Reliance Home Finance": "/lender-logos/BL/Reliance Home Finance.svg",
    "ARKA FINCAP LIMITED": "/lender-logos/WC/ARKA FINCAP LIMITED.jfif",
    "Aditya Birla Capital Limited": "/lender-logos/WC/Aditya Birla Capital Limited.jfif",
    "Ambit Finvest Pvt. Ltd.": "/lender-logos/WC/Ambit Finvest Pvt. Ltd..avif",
    "Ashv Finance": "/lender-logos/WC/Ashv Finance.png",
    "Axis Bank Limited": "/lender-logos/WC/Axis Bank Limited.png",
    "Axis Finance Ltd": "/lender-logos/WC/Axis Finance Ltd.webp",
    "Bajaj Finance Limited": "/lender-logos/WC/Bajaj Finance Limited.png",
    "Bandhan Bank": "/lender-logos/WC/Bandhan Bank.png",
    "Bank of Baroda": "/lender-logos/WC/Bank of Baroda.png",
    "Bank of India": "/lender-logos/WC/Bank of India.png",
    "Bank of Maharashtra": "/lender-logos/WC/Bank of Maharashtra.jfif",
    "Bazaari GLobal Finance Limited": "/lender-logos/WC/Bazaari GLobal Finance Limited.png",
    "Canara Bank": "/lender-logos/WC/Canara Bank.png",
    "Central Bank of India": "/lender-logos/WC/Central Bank of India.png",
    "Cholamandalam Invest. & Finance CL": "/lender-logos/WC/Cholamandalam Invest. & Finance CL.jfif",
    "Citibank": "/lender-logos/WC/Citibank.svg",
    "City Union Bank": "/lender-logos/WC/City Union Bank.jpg",
    "Clix Capital Services Private Limited": "/lender-logos/WC/Clix Capital Services Private Limited.png",
    "Credit Saison": "/lender-logos/WC/Credit Saison.png",
    "DCB Bank": "/lender-logos/WC/DCB Bank.jfif",
    "Deutsche Bank AG": "/lender-logos/WC/Deutsche Bank AG.png",
    "Federal Bank": "/lender-logos/WC/Federal Bank.png",
    "Finable": "/lender-logos/WC/Finable.png",
    "Fintree Finance Pvt Ltd": "/lender-logos/WC/Fintree Finance Pvt Ltd.png",
    "Godrej Capital": "/lender-logos/WC/Godrej Capital.webp",
    "Gosree Finance Limited": "/lender-logos/WC/Gosree Finance Limited.png",
    "HDB Financial Services Limited": "/lender-logos/WC/HDB Financial Services Limited.png",
    "HDFC Bank Limited": "/lender-logos/WC/HDFC Bank Limited.png",
    "HSBC": "/lender-logos/WC/HSBC.svg",
    "Hero Fincorp Limited": "/lender-logos/WC/Hero Fincorp Limited.webp",
    "ICICI Bank Limited": "/lender-logos/WC/ICICI Bank Limited.png",
    "IDBI Bank": "/lender-logos/WC/IDBI Bank.jpg",
    "IDFC First Bank Limited": "/lender-logos/WC/IDFC First Bank Limited.png",
    "Indian Bank": "/lender-logos/WC/Indian Bank.svg",
    "Indian Overseas Bank": "/lender-logos/WC/Indian Overseas Bank.jpeg",
    "Indifi Technologies Pvt Ltd": "/lender-logos/WC/Indifi Technologies Pvt Ltd.png",
    "Indusind Bank Limited": "/lender-logos/WC/Indusind Bank Limited.webp",
    "Jammu & Kashmir Bank": "/lender-logos/WC/Jammu & Kashmir Bank.svg",
    "Karur Vysya Bank": "/lender-logos/WC/Karur Vysya Bank.png",
    "Kotak Mahindra Bank Limited": "/lender-logos/WC/Kotak Mahindra Bank Limited.png",
    "Krazybee Services Private Limited": "/lender-logos/WC/Krazybee Services Private Limited.jfif",
    "L&T Finance Limited": "/lender-logos/WC/L&T Finance Limited.webp",
    "Lendingkart Finance Limited": "/lender-logos/WC/Lendingkart Finance Limited.png",
    "Loan Frame": "/lender-logos/WC/Loan Frame.png",
    "Loantap": "/lender-logos/WC/Loantap.png",
    "MAS Financial Services Limited": "/lender-logos/WC/MAS Financial Services Limited.jpg",
    "Mahindra Finance": "/lender-logos/WC/Mahindra Finance.jfif",
    "Moneywise Financial Services Pvt Ltd (SMC)": "/lender-logos/WC/Moneywise Financial Services Pvt Ltd (SMC).png",
    "Muthoot Finance Ltd": "/lender-logos/WC/Muthoot Finance Ltd.webp",
    "Piramal Capital & Housing Finance Ltd": "/lender-logos/WC/Piramal Capital & Housing Finance Ltd.png",
    "Poonawalla Fincorp Limited": "/lender-logos/WC/Poonawalla Fincorp Limited.jfif",
    "Protium": "/lender-logos/WC/Protium.png",
    "Punjab & Sind Bank": "/lender-logos/WC/Punjab & Sind Bank.jpg",
    "Punjab National Bank": "/lender-logos/WC/Punjab National Bank.png",
    "RBL Bank": "/lender-logos/WC/RBL Bank.png",
    "SBM Bank (India) Limited": "/lender-logos/WC/SBM Bank (India) Limited.png",
    "SMFG India Credit Company Limited": "/lender-logos/WC/SMFG India Credit Company Limited.png",
    "Shriram Finance Limited": "/lender-logos/WC/Shriram Finance Limited.png",
    "South Indian Bank": "/lender-logos/WC/South Indian Bank.png",
    "Standard Chartered Bank": "/lender-logos/WC/Standard Chartered Bank.png",
    "State Bank of India": "/lender-logos/WC/State Bank of India.png",
    "Tamilnad Mercantile Bank": "/lender-logos/WC/Tamilnad Mercantile Bank.webp",
    "Tata Capital": "/lender-logos/WC/Tata Capital.png",
    "Tata Capital Limited": "/lender-logos/WC/Tata Capital Limited.png",
    "U Gro Capital Ltd": "/lender-logos/WC/U Gro Capital Ltd.webp",
    "UCO Bank": "/lender-logos/WC/UCO Bank.png",
    "Union Bank of India": "/lender-logos/WC/Union Bank of India.png",
    "Yes Bank Limited": "/lender-logos/WC/Yes Bank Limited.png",
    "IIFL Finance": "/lender-logos/WC/IIFL Finance.png",
    "Piramal Finance": "/lender-logos/WC/Piramal Finance.png",
    "Aditya Birla Finance": "/lender-logos/WC/Aditya Birla Finance.png",
  },

};

export function getLenderLogo(lenderName, loanType) {
  const map = LENDER_LOGOS[loanType];
  if (!map) return null;
  if (map[lenderName]) return map[lenderName];
  const lower = lenderName.toLowerCase();
  // Pre-compute firstWords once — it is constant for a given lenderName.
  // Computing it inside the loop was O(n) redundant work on every iteration.
  const firstWords = lower.split(" ").slice(0, 3).join(" ");
  for (const [key, path] of Object.entries(map)) {
    const kl = key.toLowerCase();
    if (kl === lower) return path;
    if (kl.startsWith(lower) || lower.startsWith(kl)) return path;
    if (firstWords.length > 4 && kl.startsWith(firstWords)) return path;
  }
  return null;
}